import { render, staticRenderFns } from "./FaqScreen.vue?vue&type=template&id=99b55ba6&"
import script from "./FaqScreen.vue?vue&type=script&lang=js&"
export * from "./FaqScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99b55ba6')) {
      api.createRecord('99b55ba6', component.options)
    } else {
      api.reload('99b55ba6', component.options)
    }
    module.hot.accept("./FaqScreen.vue?vue&type=template&id=99b55ba6&", function () {
      api.rerender('99b55ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/support/screens/SupportScreen/FaqScreen.vue"
export default component.exports